import { firestore } from "./firebase";
import { collection, getDocs, getDoc, deleteDoc, doc as fDoc, updateDoc, setDoc, serverTimestamp } from 'firebase/firestore/lite';

import { arrayToObject, IdObject, IdObjectsWithId } from "../utils";
import * as files from "./api/files"
import cfApi from "../api/cfApi";
import { IS3UploadUrlRequest, ISignedUrl } from "../store/s3/types";

export const bannerTemplatesCollectionKey = "bannerTemplates";
export const bannerVariablesCollectionKey = "bannerVariables";
export const fileDataCollectionKey = "filesData";
export const usersCollectionKey = "users";
export const feedCollectionKey = "feeds";

export async function saveDocToCollection<T extends IdObject>(collectionKey: string, doc: T): Promise<T> {
    let docRef;
    if (doc.id && doc.id !== "new") {
        let collectionRef = collection(firestore, collectionKey);
        docRef = fDoc(collectionRef, doc.id);
        // @ts-ignore
        await updateDoc(docRef, {
            ...doc,
            updated: serverTimestamp(),
        })
    } else {
        let collectionRef = collection(firestore, collectionKey);
        docRef = fDoc(collectionRef);
        await setDoc(docRef, {
            ...doc,
            id: docRef.id,
            created: serverTimestamp(),
            updated: serverTimestamp(),
        })
    }

    return fetchDocById(collectionKey, docRef.id)
}

export async function fetchCollection<T extends IdObject>(collectionKey: string): Promise<IdObjectsWithId<T>> {
    const snapshot = await getDocs(collection(firestore, collectionKey));
    const docs = snapshot.docs.map(doc => doc.data());
    return arrayToObject(<T[]>docs)
}

export async function fetchAll<T extends IdObject>(collectionKey: string, ids: string[]): Promise<IdObjectsWithId<T>> {
    const idsStr = ids.join("&ids[]=")
    let jsonArray: { data: any[] } = await cfApi.get(`/getAll?collection=${collectionKey}&ids[]=${idsStr}`)
    jsonArray.data.filter(d => {
        // Didn't found filter out.
        return !(d['d_msg'] !== undefined && d['d_msg'] === null)
    });

    return arrayToObject(<T[]>jsonArray.data)
}

export async function getS3UploadUrl(params: IS3UploadUrlRequest): Promise<ISignedUrl> {
    console.log(params)
    let resp: { data: ISignedUrl } = await cfApi.post(`/getS3UploadUrl`, params)
    return resp.data
}

export async function putDataToS3(params: IS3UploadUrlRequest): Promise<ISignedUrl> {
    console.log(params)
    let resp: { data: ISignedUrl } = await cfApi.post(`/putDataToS3`, params)
    return resp.data
}

export async function fetchDocById<T extends IdObject>(collectionKey: string, id: string): Promise<T> {
    const docRef = fDoc(firestore, collectionKey, id);
    const snapshot = await getDoc(docRef);
    return <T>snapshot.data();
}

export async function deleteDocById(collectionKey: string, id: string): Promise<void> {
    const docRef = fDoc(firestore, collectionKey, id);
    return await deleteDoc(docRef);
}

export { files }
